// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pk-8";
export var editMode = "_pk-3";
export var headerRow = "_pk-a";
export var headerTitle = "_pk-b";
export var product = "_pk-1";
export var productDetails = "_pk-5";
export var productDivider = "_pk-7";
export var productImage = "_pk-2";
export var productInfo = "_pk-4";
export var productTitle = "_pk-6";
export var strikethrough = "_pk-9";
export var upsellProductsCard = "_pk-0";